<template>
  <el-dialog
    :title="evaluation.id ? 'Редактирование оценки 360' : 'Создание оценки 360'"
    :visible.sync="show"
    top="2vh"
    :close-on-click-modal="false"
  >
    <el-form
      size="small"
      ref="editForm"
      label-position="top"
      :model="evaluation"
      :rules="evaluationRules"
      @submit.native.prevent="saveEvaluation"
    >
      <el-form-item label="Название" prop="name">
        <el-input
          maxlength="1000"
          v-model="evaluation.name"
          ref="evaluationToFocus"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="Приветственный текст" prop="description">
        <wysiwyg
          placeholder=""
          v-model="evaluation.description"
          :hideModules="{ bold: true }"
        ></wysiwyg>
      </el-form-item>
      <el-switch
        v-model="evaluation.disabled"
        :active-value="false"
        :inactive-value="true"
        active-text="Активна"
      >
      </el-switch>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="close">Отмена</el-button>
      <el-button
        type="primary"
        size="small"
        :loading="loading"
        @click="saveEvaluation"
      > Сохранить
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "evaluation-edit-dialog",
  data() {
    return {
      show: false,
      loading: false,
      evaluation: {
        id: null,
        name: null,
        description: '',
        disabled: false,
      },
      evaluationRules: {
        name: [{required: true, message: 'Поле обязательно для заполнения', trigger: 'blur'}],
      },
    }
  },
  methods: {
    async open(evaluation) {
      if (this.$refs.editForm) {
        this.$refs.editForm.resetFields();
      }

      this.evaluation = Object.assign({}, evaluation);
      this.show = true;
      this.$nextTick(() => this.$refs.evaluationToFocus.focus());
    },
    close() {
      this.show = false;
    },
    saveEvaluation() {
      if (this.evaluation.id) {
        this.updateEvaluation();
      } else {
        this.createEvaluation();
      }
    },
    createEvaluation() {
      this.$refs.editForm.validate().then(()=> {
        this.loading = true;
        this.$api.evaluation.evaluationCreate({
          name: this.evaluation.name,
          description: this.evaluation.description,
          disabled: this.evaluation.disabled,
        })
          .then(data => {
            this.$notify.success({
              title: 'Сохранено',
              message: 'Оценка 360 успешно создана'
            });
          })
          .finally(()=>{
            this.loading = false;
            this.close();
            this.$emit('evaluation-saved');
          })
      })
    },
    updateEvaluation() {
      this.$refs.editForm.validate().then(()=> {
        this.loading = true;
        this.$api.evaluation.evaluationUpdate({
          id: this.evaluation.id,
          name: this.evaluation.name,
          description: this.evaluation.description,
          disabled: this.evaluation.disabled,
        })
          .then(data => {
            this.$notify.success({
              title: 'Обновлено',
              message: 'Оценка 360 успешно обновлена'
            });
          })
          .finally(()=>{
            this.loading = false;
            this.close();
            this.$emit('evaluation-saved');
          })
      })
    }
  }
}
</script>

<style scoped>

</style>